module.exports = __webpack_public_path__ + "static/images/recommend-logo.b8a63f3.png";